// src/components/album/AlbumImageCard.jsx
import React from 'react';
import {
    Box,
    Image,
    Text,
    Badge,
    IconButton,
    HStack,
    Spinner,
} from '@chakra-ui/react';
import { FiTrash2, FiArrowLeft, FiArrowRight } from 'react-icons/fi';

const AlbumImageCard = ({ 
    image, 
    index, 
    onRemove, 
    onMove,
    showMoveButtons = false,
    isFirst = false,
    isLast = false,
    ...props 
}) => {
    return (
        <Box
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            bg="white"
            position="relative"
            {...props}
        >
            <Box position="relative" height="200px">
                <Image
                    src={image.generated_image_url}
                    alt={image.title || `Imagem ${index + 1}`}
                    objectFit="cover"
                    width="100%"
                    height="100%"
                    fallback={<Spinner />}
                />
                <Badge
                    position="absolute"
                    top="10px"
                    right="10px"
                    colorScheme="purple"
                    borderRadius="full"
                >
                    {index + 1}
                </Badge>
                
                {showMoveButtons ? (
                    <HStack position="absolute" top="10px" left="10px" spacing={1}>
                        <IconButton
                            icon={<FiArrowLeft />}
                            size="sm"
                            colorScheme="blue"
                            isDisabled={isFirst}
                            onClick={() => onMove(index, 'up')}
                            aria-label="Mover para cima"
                        />
                        <IconButton
                            icon={<FiArrowRight />}
                            size="sm"
                            colorScheme="blue"
                            isDisabled={isLast}
                            onClick={() => onMove(index, 'down')}
                            aria-label="Mover para baixo"
                        />
                    </HStack>
                ) : (
                    <IconButton
                        icon={<FiTrash2 />}
                        colorScheme="red"
                        size="sm"
                        position="absolute"
                        top="10px"
                        left="10px"
                        onClick={() => onRemove(image.id)}
                        aria-label="Remover imagem"
                    />
                )}
            </Box>
            <Box p={3}>
                <Text fontWeight="medium" noOfLines={1}>
                    {image.title || `Imagem ${index + 1}`}
                </Text>
            </Box>
        </Box>
    );
};

export default AlbumImageCard;